import { FieldArray, useFormikContext } from 'formik'

import {
  FormBody,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { Content } from '../../../Modal'
import { PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD } from '../EditBuildingAndCategoryModal.constants'
import {
  createEmptyMappingRow,
  getCanAddMappingRow,
} from '../EditBuildingAndCategoryModal.utils'

import * as styles from './EditBuildingAndCategoryModalFormBody.module.css'

function EditBuildingAndCategoryModalFormBody({
  Fields,
  actionsProps,
  contentClassName,
  contentProps,
  formFieldsProps,
  isLoading,
  notifications,
  submitQaName,
  validationErrorsNotificationProps,
  onCancel,
}) {
  const { dirty, isSubmitting, values } = useFormikContext()

  useFormValidationErrorsNotification(validationErrorsNotificationProps)

  function handleCancel() {
    return onCancel?.({ dirty, values })
  }

  const mappingRows = values[PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD]

  const canAddMappingRow = getCanAddMappingRow(
    mappingRows[mappingRows.length - 1]
  )

  return (
    <FieldArray
      name={PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD}
      validateOnChange={false}
    >
      {({ push, remove }) => {
        function handleAddMappingRow() {
          push(createEmptyMappingRow())
        }

        return (
          <FormBody
            actionsProps={{
              ...actionsProps,
              ButtonAdd: false,
              ButtonClear: false,
              UploadComponent: false,
              cancelProps: {
                ...actionsProps?.cancelProps,
                isSkeleton: isLoading,
                onClick: handleCancel,
              },
              className: styles.actions,
              isSubmitting,
              submitProps: {
                ...actionsProps?.submitProps,
                isLoading: isSubmitting,
                isSkeleton: isLoading,
                qaName: submitQaName,
                title: 'Modal.SaveBtnKey',
              },
            }}
          >
            <Content {...contentProps} className={contentClassName}>
              <FormInlineNotifications notifications={notifications} />
              <Fields
                {...formFieldsProps}
                canAddMappingRow={canAddMappingRow}
                isLoading={isLoading}
                isSubmitting={isSubmitting}
                mappingRows={mappingRows}
                onAddMappingRow={handleAddMappingRow}
                onRemoveMappingRow={remove}
              />
            </Content>
          </FormBody>
        )
      }}
    </FieldArray>
  )
}

export default EditBuildingAndCategoryModalFormBody
